/**
 * עמלה קבועה (₪) לחדר בסוכני חבילות נופש (FlightsHotel / DynamicPackage) — ברירת מחדל מעמלה "כללית"
 * ובחירת override לכל סלוט חדר עם flag ידני.
 */

const VP_FLIGHTS_HOTEL_NORMALIZED = new Set(["flightshotel", "dynamicpackage"]);

function normalizedDealType(raw) {
  return String(raw || "")
    .replace(/\s+/g, "")
    .trim()
    .toLowerCase();
}

export function isVacationPackagesFlightsHotelAgentDeal(selectedResult) {
  if (!selectedResult || typeof selectedResult !== "object") return false;
  const dt =
    selectedResult.dealType ??
    selectedResult.dealtype ??
    selectedResult.fullDeal?.dealType ??
    selectedResult.fullDeal?.dealtype;
  const n = normalizedDealType(dt);
  return VP_FLIGHTS_HOTEL_NORMALIZED.has(n);
}

/**
 * ברירת מחדל מהשדה העמלה הכללית (HandlingFeePicker במצב "+" בלבד).
 */
export function vacationPackageGlobalAgentMarkupIls(handleFeeData) {
  if (!handleFeeData || handleFeeData.type !== "+") return 0;
  const v = Number(handleFeeData.value);
  return Number.isFinite(v) && v >= 0 ? v : 0;
}

/**
 * Σ room.agentMarkup ?? global (+) ?? 0
 */
export function resolveVacationPackageRoomMarkupIls(roomSlot, handleFeeData) {
  const global = vacationPackageGlobalAgentMarkupIls(handleFeeData);
  if (handleFeeData?.type !== "+") return 0;
  const raw = roomSlot?.agentMarkup;
  const hasExplicit =
    raw !== undefined && raw !== null && raw !== "" && Number.isFinite(Number(raw));
  if (hasExplicit) return Number(raw);
  return global;
}

/** True when the agent typed עמלה לחדר on at least one slot. */
export function vacationPackageHasManualRoomMarkup(roomsAndPaxInfo) {
  return (
    Array.isArray(roomsAndPaxInfo) &&
    roomsAndPaxInfo.some((slot) => Boolean(slot?.agentMarkupManuallyEdited))
  );
}

/** Sum of configured per-slot markups (explicit agentMarkup or global default). */
export function sumVacationPackageConfiguredRoomMarkupIls(
  roomsAndPaxInfo,
  handleFeeData
) {
  if (!Array.isArray(roomsAndPaxInfo)) return 0;
  let sum = 0;
  for (const slot of roomsAndPaxInfo) {
    const v = Number(resolveVacationPackageRoomMarkupIls(slot, handleFeeData));
    if (Number.isFinite(v) && v > 0) sum += v;
  }
  return Math.round(sum * 100) / 100;
}

export function vpRoomMarkupDevTrace(tag, payload) {
  try {
    if (typeof import.meta !== "undefined" && import.meta.env?.DEV) {
      // eslint-disable-next-line no-console
      console.log(tag, payload ?? {});
    }
  } catch {
    /* ignore */
  }
}

/**
 * DEV: לאימות שעמלת סוכן קבועה בחבילות מטופלת בש"ח — בלי להכפיל בשער קטלוג/USD.
 */
export function emitVacationPackageMarkupCurrencyAudit(payload) {
  vpRoomMarkupDevTrace("[VACATION_PACKAGE_MARKUP_CURRENCY_BUG_AUDIT]", payload ?? {});
}

/**
 * DEV: ביקורת מטבע לתוספות (מזוודה וכו׳) בחבילות נופש — עמלה קבועה בש"ח בלי כפול USD→ILS.
 */
export function emitVacationPackageExtraCurrencyAudit(payload) {
  vpRoomMarkupDevTrace("[VACATION_PACKAGE_EXTRA_CURRENCY_AUDIT]", payload ?? {});
}
